__turbopack_context__.v({
  "cardsGrid": "J8hvla_cardsGrid",
  "container": "J8hvla_container",
  "heading": "J8hvla_heading",
  "imageWrap": "J8hvla_imageWrap",
  "insetBorder": "J8hvla_insetBorder",
  "partnerActions": "J8hvla_partnerActions",
  "partnerCard": "J8hvla_partnerCard",
  "partnerContent": "J8hvla_partnerContent",
  "partnerDescription": "J8hvla_partnerDescription",
  "partnerImage": "J8hvla_partnerImage",
  "partnerTitle": "J8hvla_partnerTitle",
  "root": "J8hvla_root" + " " + __turbopack_context__.i(46473)["sectionPadding"],
});
